import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ProgressBar } from "react-loader-spinner";

import Cookies from "js-cookie";

import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import UniversalHeader from "../commonComponents/universalHeader/UniversalHeader";
import UniversalInputComponent from "../commonComponents/universalInputComponent/UniversalInputComponent";
import AppFooterRHF from "../commonComponents/appFooterRHF/AppFooterRHF";
import ButtonsBlock from "../../GeneralComponents/buttonsBlock/ButtonsBlock";
import ResultModalWindow from "../commonComponents/ResultModalWindow/ResultModalWindow";
import ModalWindowWithInputs from "../../GeneralComponents/modalWindowWithInputs/modalWindowWithInputs";
import LoaderWithOverlay from "../../GeneralComponents/loaderWithOverlay/loaderWithOverlay";

import { fetchWithToken } from "../../../interceptors/fetchInterceptor";
import { clearNewStatement } from "../../../redux/statementReducer/actionsStatement";

import {
  deleteDataFromIndexedDB,
  logIndexedDBData,
  saveDataToIndexedDB,
} from "../../../services/indexedDBService";

import {
  clearOptions,
  headerFields,
  interestedEntity,
  interestedIndividual,
  optionsForPasswordModal,
  representPerson,
  setButtonVisibilityByAccess,
  setDefaultOptions,
  setDefaultOptionsRepresent,
  setDocOptionsDocumentsFromDictionariesInterested,
  setDocOptionsDocumentsFromDictionariesRepresent,
  setGridsByMode,
  setOblOptionsFromDictionariesInterested,
  setOblOptionsFromDictionariesRepresent,
  setOptionsInterestedPerson,
  setOptionsRepresentPerson,
  setRequiredForRayonIdProvivisionInfromation,
  toggleSearchButton,
} from "./optionsStatementProvisionInformationRHF";

import {
  API_ADD_STATEMENT_PROVISION_INFORMATION,
  API_DOWNLOAD_FILEREPORT_PROVISION_INFO,
  API_DOWNLOAD_STATEMENT_PROVISIONINFORMATION,
  API_FOR_AVEST_SIGN,
  API_GET_INFO_BY_PERS_NUM,
  API_GET_INFO_BY_PERS_NUM_WITH_SIGN,
  API_GET_INFO_BY_REG_NUM,
  API_GET_STATEMENT_PROVISION_INFORMATION,
  MAIN_URL,
  PORT,
  PORT_FOR_INTEGRATION,
} from "../../../constants/constants";

import styles from "./statementProvisionInformationRHF.module.css";

const storeName = "statements";

export default function StatementProvisionInformationRHF() {
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
    setError,
    getValues,
    reset,
    trigger,
  } = useForm({ mode: "onChange" });

  const {
    register: registerModal,
    handleSubmit: handleSubmitModal,
    control: controlModal,
    formState: { errors: errorsModal },
    setValue: setValueModal,
    getValues: getValuesModal,
  } = useForm({
    mode: "onChange",
  });

  const userId = Cookies.get("userId");
  const mode = window.location.pathname.includes("add") ? "add" : "view";
  const downloadAPI = "https://gimc.by:8080/boatCardApp/download/";
  const validationKeys = ["docDateIssue", "agentDocDate", "appDate"];
  const id = mode === "view" && window.location.pathname.split("/").at(-1);
  const personTypeByPath = window.location.pathname.includes("individual") ? 1 : 2;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [options, setOptions] = useState({
    header: headerFields,
    interested: window.location.pathname.includes("individual") ? interestedIndividual : interestedEntity,
    represent: representPerson,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingWithOverlay, setIsLoadingWithOverlay] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [newData, setNewData] = useState({
    appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
    personType: window.location.pathname.includes("individual") ? 1 : 2,
  });
  const [file, setFile] = useState("");
  const [viewFileName, setViewFileName] = useState("");
  const [showResultModal, setShowResultModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [registrationResult, setRegistrationResult] = useState("");
  const [buttonType, setButtonType] = useState("");
  const [appId, setAppId] = useState(null);
  const [errorText, setErrorText] = useState("");
  const [headerText, setHeaderText] = useState("");
  const [isPrinted, setIsPrinted] = useState(false);
  const [indexedDBData, setIndexedDBData] = useState(null);

  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });

  const searchAccess = useChapterActionIdMatch(
    sortedMenuNames?.PROVISION_INFORMATION?.searchEGR?.chapterActionId,
  );

  const printAccess = useChapterActionIdMatch(
    sortedMenuNames?.PROVISION_INFORMATION?.printApplication?.chapterActionId,
  );

  // const watchAgentGorod = watch("agentGorodId");
  const watchGorod = watch("gorodId");

  const getUserInfoById = async (propsBtnType) => {
    const { persNum, unp, agentPersNum } = getValues();
    const { pw } = getValuesModal();

    const setDataAfterRequest = async (data) => {
      for (const [key, val] of Object.entries(data)) {
        if (val) {
          newData[key] = val;
          setValue(key, val);
        }
      }
      setNewData(structuredClone(newData, getValues()));
    };

    const setOptionsAfterRequest = async (data) => {
      if (data.oblId) {
        setOptions({
          ...options,
          interested: await setOptionsInterestedPerson(data, "oblId", personTypeByPath),
        });
      }
      if (data.rayonId) {
        setOptions({
          ...options,
          interested: await setOptionsInterestedPerson(data, "rayonId", personTypeByPath),
        });
      }
      if (data.agentOblId) {
        setOptions({
          ...options,
          represent: await setOptionsRepresentPerson(data, "agentOblId"),
        });
      }
      if (data.agentRayonId) {
        setOptions({
          ...options,
          represent: await setOptionsRepresentPerson(data, "agentRayonId"),
        });
      }
    };
    if (buttonType) {
      const value = buttonType === "persNum" ? persNum : agentPersNum;
      const key = buttonType;
      if (value) {
        if (!/^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/.test(value)) {
          setError(key, {
            type: "manual",
            message: `Введите номер в формате "0000000A000AA0"`,
          });
          return;
        } else {
          // индификационный номер
          clearErrors(key);
          setIsLoadingModal(true);
          await fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_INFO_BY_PERS_NUM + value, {
            headers: { "Content-Type": "application/json" },
          })
            .then(async (res) => {
              if (!res.ok) {
                throw new Error(`Ошибка сети: ${res.status}`);
              }
              return res.json();
            })
            .then(async (dataForInnerRequest) => {
              let resInner;
              let resWithData;

              try {
                resInner = await fetch(API_FOR_AVEST_SIGN, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ ...dataForInnerRequest, pw: pw }),
                });
              } catch (error) {
                resWithData = await fetchWithToken(
                  MAIN_URL +
                    PORT_FOR_INTEGRATION +
                    API_GET_INFO_BY_PERS_NUM_WITH_SIGN +
                    `${userId}/${value}?agent=${key === "persNum" ? 1 : 2}`,
                  {
                    method: "POST",
                    body: JSON.stringify({
                      headers: null,
                      body: null,
                      identificationNumber: value,
                      log: false,
                    }),
                    headers: { "Content-Type": "application/json" },
                  },
                );
              }

              if (resInner) {
                if (!resInner.ok) {
                  const errorText = await resInner.text();
                  if (errorText === "Invalid container password") {
                    throw new Error(`Ошибка подписи! Неверный пароль.`);
                  }
                  resWithData = await fetchWithToken(
                    MAIN_URL +
                      PORT_FOR_INTEGRATION +
                      API_GET_INFO_BY_PERS_NUM_WITH_SIGN +
                      `${userId}/${value}?agent=${key === "persNum" ? 1 : 2}`,
                    {
                      method: "POST",
                      body: JSON.stringify({
                        headers: null,
                        body: null,
                        identificationNumber: value,
                        log: false,
                      }),
                      headers: { "Content-Type": "application/json" },
                    },
                  );
                } else {
                  const dataWithSign = await resInner.json();

                  resWithData = await fetchWithToken(
                    MAIN_URL +
                      PORT_FOR_INTEGRATION +
                      API_GET_INFO_BY_PERS_NUM_WITH_SIGN +
                      `${userId}/${value}?agent=${key === "persNum" ? 1 : 2}`,
                    {
                      method: "POST",
                      body: JSON.stringify(dataWithSign),
                      headers: { "Content-Type": "application/json" },
                    },
                  );
                }
              }

              const dataWithInformation = await resWithData.json();
              if (!resWithData.ok) {
                throw new Error(dataWithInformation.message);
              } else {
                setOptionsAfterRequest(dataWithInformation);
                setDataAfterRequest(dataWithInformation);
                setShowPasswordModal(false);
              }
            })
            .catch((error) => {
              setErrorText(error.message);
              setHeaderText("Заполните поля вручную или повторите заново");
              setRegistrationResult("error");
              setShowResultModal(true);
              clearErrors(key);
              setIsLoadingModal(false);
            });
          // setButtonType("");
          clearErrors(key);
          setIsLoadingModal(false);
        }
      } else {
        setError(key, {
          type: "manual",
          message: "Для поиска заполните поле",
        });
      }
    } else if (propsBtnType) {
      if (unp) {
        if (unp.trim().length !== 9 || !/^[\d]+$/.test(unp)) {
          setError("unp", {
            type: "manual",
            message: "Для поиска введите 9 цифр",
          });
          return;
        } else {
          clearErrors("unp");
          setIsLoadingModal(true);

          const data = await fetchWithToken(
            MAIN_URL + PORT_FOR_INTEGRATION + API_GET_INFO_BY_REG_NUM + `?regNum=${unp}`,
          ).then(async (res) => {
            if (!res.ok) {
              const result = await res.json();
              const errText = result.message;
              setErrorText(errText);
              setHeaderText("Заполните поля вручную");
              setRegistrationResult("error");
              setShowResultModal(true);
              clearErrors("unp");
              setOptions({
                ...options,
                interested: toggleSearchButton(false),
              });
              setIsLoadingModal(false);
            }
            return res.json();
          });

          newData["egrNum"] = getValues("unp");
          setValue("egrNum", getValues("unp"));
          setDataAfterRequest(data);
          setOptionsAfterRequest(data);

          setOptions({
            ...options,
            interested: toggleSearchButton(true),
          });
          clearErrors("unp");
          setNewData(structuredClone(newData));
          setIsLoadingModal(false);
        }
      } else {
        setError("unp", {
          type: "manual",
          message: "Для поиска заполните поле УНП",
        });
      }
    }
  };

  const resolveSubmit = async (data) => {
    const formData = new FormData();

    if (file !== undefined) {
      formData.append(`file`, file);
    }

    const newStatement = { ...newData, ...data };
    delete newStatement.stranId;
    delete newStatement.agentCountry;

    formData.append("data", JSON.stringify(newStatement));

    try {
      const request = await fetchWithToken(MAIN_URL + PORT + API_ADD_STATEMENT_PROVISION_INFORMATION, {
        method: "POST",
        body: formData,
      });

      if (request.status === 200) {
        const response = await request.text();
        await deleteDataFromIndexedDB(storeName, 1);
        setAppId(response);
        setShowResultModal(!showResultModal);
        setRegistrationResult("success");
      } else {
        const response = await request.text();
        await saveDataToIndexedDB(storeName, newStatement);
        setErrorText(response);
        setShowResultModal(!showResultModal);
        setRegistrationResult("error");
      }
    } catch (error) {
      setShowResultModal(true);
      setRegistrationResult("error");
      setErrorText("Проверьте соединение с интернетом");
      setHeaderText("Ошибка соединения");
      await saveDataToIndexedDB(storeName, newStatement);
    }
  };

  const handleCloseApp = () => {
    clearOptions();
    dispatch(clearNewStatement());
    navigate(-1);
  };

  const handleFile = (e) => {
    if (e) {
      if (e.target.files[0]) {
        setFile(e.target.files[0]);
      }
    }
  };

  const clearFile = (e) => {
    setFile("");
    e.preventDefault();
  };

  const handleDownloadFile = async (e) => {
    if (e) {
      let response = null;
      if (window.location.pathname.includes("decisioncard")) {
        response = await fetchWithToken(
          `${MAIN_URL}${PORT}${API_DOWNLOAD_FILEREPORT_PROVISION_INFO}${String(newData.id)}`,
        );
      } else {
        if (await trigger()) {
          const newStatement = { ...newData, ...getValues() };
          delete newStatement.stranId;
          delete newStatement.agentCountry;
          setIsLoadingWithOverlay(true);
          response = await fetchWithToken(
            `${MAIN_URL}${PORT}${API_DOWNLOAD_STATEMENT_PROVISIONINFORMATION}${personTypeByPath}`,
            {
              method: "POST",
              body: JSON.stringify(newStatement),
            },
          );
        }
      }
      setIsLoadingWithOverlay(false);
      if (response && response.ok) {
        const formData = await response.formData();
        const filePdf = formData.get("pdf");
        const fileDocx = formData.get("docx");
        const fileUrl = URL.createObjectURL(filePdf ? filePdf : fileDocx);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = filePdf ? filePdf.name : fileDocx.name;
        link.click();
        setIsPrinted(true);
      }
    }
  };

  const handleCustomValidation = (data, key) => {
    if (typeof data === "object") {
      for (let item of key) {
        if (new Date(data.item) > new Date()) {
          setError(item, {
            type: "manual",
            message: "Дата не может быть позднее текущей",
          });
          return false;
        } else if (new Date(data[item]) < new Date("1996-09-26T00:00:00.000+03:00")) {
          setError(item, {
            type: "manual",
            message: "Дата не может быть ранее 26.09.1996",
          });
          return false;
        } else {
          clearErrors(item);
          return true;
        }
      }
    } else {
      if (new Date(data) > new Date()) {
        setError(key, {
          type: "manual",
          message: "Дата не может быть позднее текущей",
        });
        return false;
      } else if (new Date(data) < new Date("1996-09-26T00:00:00.000+03:00")) {
        setError(key, {
          type: "manual",
          message: "Дата не может быть ранее 26.09.1996",
        });
        return false;
      } else {
        clearErrors(key);
        return true;
      }
    }
  };

  const setOptionsFromLibs = () => {
    if (Object.values(dictionaryReducer.identificationDocuments).length > 0) {
      setDocOptionsDocumentsFromDictionariesInterested(dictionaryReducer.identificationDocuments);
      setDocOptionsDocumentsFromDictionariesRepresent(dictionaryReducer.identificationDocuments);
    }
    if (Object.values(dictionaryReducer.allOblast).length > 0) {
      setOblOptionsFromDictionariesInterested(dictionaryReducer.allOblast);
      setOblOptionsFromDictionariesRepresent(dictionaryReducer.allOblast);
    }
  };

  useEffect(() => {
    const asyncWatch = async (value, { name, type }) => {
      if (type !== undefined) {
        if (newData[name] !== value[name]) {
          newData[name] = value[name];
          if (name === "agentOblId" || name === "agentRayonId" || name === "agentGorodId") {
            setOptions({
              ...options,
              represent: await setOptionsRepresentPerson(value, name),
            });
            if (name === "agentOblId") {
              setValue("agentRayonId", undefined);
              setValue("agentGorodId", undefined);
            }
          }
          if (name === "oblId" || name === "rayonId" || name === "gorodId") {
            setOptions({
              ...options,
              interested: await setOptionsInterestedPerson(value, name, newData.personType),
            });
            if (name === "oblId") {
              setValue("rayonId", undefined);
              setValue("gorodId", undefined);
            }
          }
        }
        if (validationKeys.includes(name)) handleCustomValidation(value[name], name);
      }
    };
    const subscription = watch(asyncWatch);
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    setOptions({
      ...options,
      interested: setRequiredForRayonIdProvivisionInfromation(watchGorod, "gorodId", personTypeByPath),
    });
  }, [watchGorod]);

  useEffect(() => {
    if (mode === "add") {
      Object.values(options).map((item) => {
        item.inputsOptions &&
          Object.values(item.inputsOptions).map((elem) => {
            if (elem.defaultValue) {
              setValue(elem.key, elem.defaultValue);
            }
          });
      });
    } else {
      Object.values(options).map((item) => {
        item.inputsOptions &&
          Object.values(item.inputsOptions).map((elem) => {
            if (elem.hasOwnProperty("defaultValue")) {
              newData[elem.key] = elem.defaultValue;
            }
          });
        setNewData(structuredClone(newData));
      });
    }
  }, [options]);

  useEffect(() => {
    async function fetchData() {
      if (id) {
        const responseStatement = await fetchWithToken(
          MAIN_URL + PORT + API_GET_STATEMENT_PROVISION_INFORMATION + String(id),
        );
        const dataStatement = await responseStatement.json();
        if (dataStatement.oblId) {
          dataStatement.stranId = "Республика Беларусь";
          setOptions({
            ...options,
            interested: await setOptionsInterestedPerson(dataStatement, "oblId", dataStatement.personType),
          });
        }
        if (dataStatement.rayonId) {
          setOptions({
            ...options,
            interested: await setOptionsInterestedPerson(dataStatement, "rayonId", dataStatement.personType),
          });
        }
        if (dataStatement.agentOblId) {
          setOptions({
            ...options,
            represent: await setOptionsRepresentPerson(dataStatement, "agentOblId"),
          });
        }
        if (dataStatement.agentRayonId) {
          setOptions({
            ...options,
            represent: await setOptionsRepresentPerson(dataStatement, "agentRayonId"),
          });
        }
        dataStatement.appFileId = dataStatement?.fileId;
        dataStatement.viewFileName = dataStatement?.fileName;

        setOptions({
          ...options,
          represent: await setDefaultOptionsRepresent(dataStatement),
        });
        setNewData({ ...newData, ...dataStatement });
      }
    }
    if (id) {
      fetchData();
    } else {
      const setDefaultOptions = async () => {
        setOptions({
          ...options,
          represent: await setDefaultOptionsRepresent(true),
        });
      };
      setDefaultOptions();
    }
  }, []);

  useEffect(() => {
    setOptionsFromLibs();
  }, [dictionaryReducer]);

  useEffect(() => {
    setOptionsFromLibs();
  }, []);

  useEffect(() => {
    if (!!mode && !!newData.personType) setOptions({ ...setGridsByMode(mode, newData.personType) });
    setIsLoading(false);
  }, [mode, newData.personType]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await logIndexedDBData(storeName);
      setIndexedDBData(data);
    };

    fetchData();
  }, [storeName]);

  useEffect(() => {
    if (
      indexedDBData &&
      indexedDBData[0] &&
      indexedDBData[0]?.data &&
      personTypeByPath === indexedDBData[0]?.data?.personType
    ) {
      const DBData = indexedDBData[0].data;
      const setData = async () => {
        if (DBData.oblId) {
          DBData.stranId = "Республика Беларусь";
          setOptions({
            ...options,
            interested: await setOptionsInterestedPerson(DBData, "oblId", DBData.personType),
          });
        }
        if (DBData.rayonId) {
          setOptions({
            ...options,
            interested: await setOptionsInterestedPerson(DBData, "rayonId", DBData.personType),
          });
        }
        if (DBData.agentOblId) {
          setOptions({
            ...options,
            represent: await setOptionsRepresentPerson(DBData, "agentOblId"),
          });
        }
        if (DBData.agentRayonId) {
          setOptions({
            ...options,
            represent: await setOptionsRepresentPerson(DBData, "agentRayonId"),
          });
        }

        // setOptions({
        //   ...options,
        //   represent: await setDefaultOptionsRepresent(DBData),
        // });
        setNewData({ ...newData, ...DBData });
        reset(DBData);
      };

      setData();
    }
  }, [indexedDBData]);

  useEffect(() => {
    if (newData.personType === 2) {
      setOptions({
        ...options,
        interested: setButtonVisibilityByAccess(searchAccess),
      });
    }
  }, [searchAccess]);

  useEffect(() => {
    return () => {
      setDefaultOptions();
    };
  }, []);

  return (
    <>
      <div className={styles["content-container"]}>
        <h1 className={styles["main-text"]}>Заявление</h1>
        <p className={styles["description-text"]}>
          {newData.personType === 1
            ? "о предоставлении информации из судовой книги"
            : "о получении информации из судовой книги"}
        </p>
        {isLoading ? (
          <div className={`d-flex flex-column align-items-center `}>
            <ProgressBar
              height="80"
              width="80"
              ariaLabel="progress-bar-loading"
              wrapperStyle={{}}
              wrapperClass="progress-bar-wrapper"
              borderColor="#D2AF8E"
              barColor="#BC8653"
            />
          </div>
        ) : (
          <form onSubmit={handleSubmit(resolveSubmit)}>
            <UniversalHeader
              options={options.header}
              mode={mode}
              styles={styles}
              register={register}
              control={control}
              setValue={setValue}
              clearErrors={clearErrors}
              newData={newData}
            />
            <UniversalInputComponent
              options={options.interested}
              mode={mode}
              styles={styles}
              register={register}
              newData={newData}
              control={control}
              setValue={setValue}
              errors={errors}
              clearErrors={clearErrors}
              handleCustomButton={(e) => {
                if (e.currentTarget.dataset.key === "persNum") {
                  if (!/^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/.test(getValues("persNum"))) {
                    setError("persNum", {
                      type: "manual",
                      message: `Введите номер в формате "0000000A000AA0"`,
                    });
                  } else {
                    setButtonType(e.currentTarget.dataset.key);
                    setShowPasswordModal(true);
                  }
                } else {
                  getUserInfoById(e.currentTarget.dataset.key);
                }
              }}
            />
            <UniversalInputComponent
              options={options.represent}
              mode={mode}
              styles={styles}
              register={register}
              newData={newData}
              control={control}
              setValue={setValue}
              errors={errors}
              clearErrors={clearErrors}
              handleCustomButton={(e) => {
                if (!/^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/.test(getValues("agentPersNum"))) {
                  setError("agentPersNum", {
                    type: "manual",
                    message: `Введите номер в формате "0000000A000AA0"`,
                  });
                } else {
                  setButtonType(e.currentTarget.dataset.key);
                  setShowPasswordModal(true);
                }
              }}
            />
            <AppFooterRHF
              mode={mode}
              register={register}
              control={control}
              setValue={setValue}
              clearErrors={clearErrors}
              errors={errors}
              newData={newData}
              styles={styles}
              handleFile={handleFile}
              clearFile={clearFile}
              fileName={file?.name}
              fileDownloadApi={downloadAPI}
              viewFileName={viewFileName}
            />
            <ButtonsBlock
              styles={styles}
              closeBtnText={(!isPrinted || window.location.pathname.includes("decisioncard")) && "Закрыть"}
              extraBtnText={
                window.location.pathname.includes("decisioncard")
                  ? "Выгрузить файл"
                  : mode === "add" && printAccess
                  ? "Распечатать"
                  : false
              }
              saveBtnText={mode === "add" && "Зарегистрировать"}
              handleExtraBtn={handleDownloadFile}
              handleCloseBtn={handleCloseApp}
            />
          </form>
        )}
      </div>

      <ModalWindowWithInputs
        showModal={showPasswordModal}
        setShowModal={setShowPasswordModal}
        textButton={"Найти"}
        externalStyles={styles}
        inputsOptions={optionsForPasswordModal}
        mode={"add"}
        handleSubmit={handleSubmitModal}
        register={registerModal}
        control={controlModal}
        setValue={setValueModal}
        errors={errorsModal}
        clearErrors={clearErrors}
        handle={getUserInfoById}
        isLoadingModal={isLoadingModal}
      />

      {showResultModal && (
        <ResultModalWindow
          appId={appId}
          show={showResultModal}
          setShow={setShowResultModal}
          result={registrationResult}
          handleCloseApp={handleCloseApp}
          errorText={errorText}
          headerTextExternal={headerText}
        />
      )}
      <LoaderWithOverlay isLoading={isLoadingWithOverlay} />
    </>
  );
}
